export const actions = {
  ACTIVIDAD_LOAD_REQUESTED: 'ACTIVIDAD_LOAD_REQUESTED',
  ACTIVIDAD_LOAD_SUCCEEDED: 'ACTIVIDAD_LOAD_SUCCEEDED',
  ACTIVIDAD_LOAD_FAILED: 'ACTIVIDAD_LOAD_FAILED',

  ERRONEOS_LOAD_REQUESTED: 'ERRONEOS_LOAD_REQUESTED',
  ERRONEOS_LOAD_SUCCEEDED: 'ERRONEOS_LOAD_SUCCEEDED',
  ERRONEOS_LOAD_FAILED: 'ERRONEOS_LOAD_FAILED',

  ERRONEOS_BY_ORIGEN_DESTINO_LOAD_REQUESTED: 'ERRONEOS_BY_ORIGEN_DESTINO_LOAD_REQUESTED',
  ERRONEOS_BY_ORIGEN_DESTINO_LOAD_SUCCEEDED: 'ERRONEOS_BY_ORIGEN_DESTINO_LOAD_SUCCEEDED',
  ERRONEOS_BY_ORIGEN_DESTINO_LOAD_FAILED: 'ERRONEOS_BY_ORIGEN_DESTINO_LOAD_FAILED',

  ERRONEO_UPDATE_REQUESTED: 'ERRONEO_UPDATE_REQUESTED',
  ERRONEO_UPDATE_SUCCEEDED: 'ERRONEO_UPDATE_SUCCEEDED',
  ERRONEO_UPDATE_FAILED: 'ERRONEO_UPDATE_FAILED',

  PROCESADOS_LOAD_REQUESTED: 'PROCESADOS_LOAD_REQUESTED',
  PROCESADOS_LOAD_SUCCEEDED: 'PROCESADOS_LOAD_SUCCEEDED',
  PROCESADOS_LOAD_FAILED: 'PROCESADOS_LOAD_FAILED',

  INSTANCIA_LOAD_REQUESTED: 'INSTANCIA_LOAD_REQUESTED',
  INSTANCIA_LOAD_SUCCEEDED: 'INSTANCIA_LOAD_SUCCEEDED',
  INSTANCIA_LOAD_FAILED: 'INSTANCIA_LOAD_FAILED',

  INSTANCIA_UPDATE_REQUESTED: 'INSTANCIA_UPDATE_REQUESTED',
  INSTANCIA_UPDATE_SUCCEEDED: 'INSTANCIA_UPDATE_SUCCEEDED',
  INSTANCIA_UPDATE_FAILED: 'INSTANCIA_UPDATE_FAILED',
}

export const getActividadAction = dispatch => {
  dispatch({
    type: actions.ACTIVIDAD_LOAD_REQUESTED,
  })
}

export const getErroneosAction = dispatch => {
  dispatch({
    type: actions.ERRONEOS_LOAD_REQUESTED,
  })
}

export const updateErroneoAction = (dispatch, payload) => {
  dispatch({
    type: actions.ERRONEO_UPDATE_REQUESTED,
    payload,
  })
}

export const getErroneosByOrigenDestinoAction = (dispatch, entidadOrigen, entidadDestino) => {
  dispatch({
    type: actions.ERRONEOS_BY_ORIGEN_DESTINO_LOAD_REQUESTED,
    payload: {
      entidadOrigen,
      entidadDestino,
    },
  })
}

export const getProcesadoAction = dispatch => {
  dispatch({
    type: actions.PROCESADOS_LOAD_REQUESTED,
  })
}

export const getInstanciasAction = dispatch => {
  dispatch({
    type: actions.INSTANCIA_LOAD_REQUESTED,
  })
}

export const updateInstanciaAction = (dispatch, payload) => {
  dispatch({
    type: actions.INSTANCIA_UPDATE_REQUESTED,
    payload,
  })
}
